import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { Box, IconButton, InputAdornment, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setSorting } from '../../../redux/reducer/sortingSlice';
import { RootState } from '../../../redux/store';
import { setSearchFilter } from '../../../redux/reducer/tableSearchSlice';
import { SearchOutlined } from '@mui/icons-material';
import { useEffect, useState } from 'react';

interface HeadCell {
    id: string;
    label: string;
    disablePadding?: boolean;
    numeric?: boolean;
    width?: string;
    isFilterable?: boolean;
    isSorting?: boolean;
    isSticky?: {
        position: "left" | "right";
        positionStart: string;
        zIndex?: number;
    };
}

interface TableHeadListProps {
    headCells: HeadCell[];
}

const TableHeadList = ({ headCells }: TableHeadListProps) => {
    const dispatch = useDispatch();
    const { orderBy, order } = useSelector((state: RootState) => state.sorting);
    const searchFilter = useSelector((state: RootState) => state.tableSearch);
    const showFilters = useSelector((state: RootState) => state.showFilters.showFilters);
    const [search, setSearch] = useState<{ tableId: string; query: string }>({
        tableId: "",
        query: "",
    });

    const handleSortingChange = (newOrderBy: string, orderNew: string) => {
        let newOrder: "asc" | "desc";
        if (orderBy === orderNew) {
            newOrder = order === "asc" ? "desc" : "asc";
        } else {
            newOrder = "asc";
        }
        dispatch(
            setSorting({
                orderBy: newOrderBy,
                order: newOrder,
            })
        );
    };
    const handleSearchChange = (tableId: string, value: string) => {
        setSearch({ tableId, query: value });
    };
    const handleSearchClick = (tableId: string) => {
        dispatch(setSearchFilter({ tableId, searchString: search.query }));
    };

    useEffect(() => {
        if(searchFilter.tableId === null)
        setSearch({ tableId: "", query: "" });
    }, [searchFilter]);
    return (
        <TableHead sx={{ position: "sticky", top: 0, zIndex: 5, backgroundColor: "#ffffff", }} >
            {showFilters &&
                <TableRow sx={{ position: "sticky", top: 0, backgroundColor: "#ffffff", zIndex: 5 }}>
                    {headCells.map((headCell) => (
                        <TableCell
                            padding='none'
                            key={headCell.id}
                            sx={{
                                borderRightWidth: 1,
                                borderRightStyle: "solid",
                                borderRightColor: "grey.300",
                                borderTop: "1px solid #e0e0e0",
                                borderLeftWidth: 1,
                                borderLeftStyle: "solid",
                                borderLeftColor: "grey.300",
                                padding: headCell.disablePadding ? "none" : "normal",
                                width: headCell.width,
                                backgroundColor: "#ffffff",
                                ...(headCell.isSticky && {
                                    position: "sticky",
                                    [headCell.isSticky.position]: headCell.isSticky.positionStart || 0,
                                    zIndex: headCell.isSticky.zIndex ?? 5,
                                }),
                            }}
                        >
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                {headCell.isFilterable && (
                                    <TextField
                                        fullWidth
                                        placeholder={`Search ${headCell.label} ...`}
                                        variant="outlined"
                                        size="small"
                                        value={search.tableId === headCell.id ? search.query : ""}
                                        onChange={(e) => handleSearchChange(headCell.id, e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                handleSearchClick(headCell.id);
                                            }
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => handleSearchClick(headCell.id)}>
                                                        <SearchOutlined fontSize="small" color="primary" />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            sx: {
                                                "& input::placeholder": { color: "black", opacity: 1 },
                                            },
                                        }}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                border: "none",
                                                "& fieldset": { border: "none" },
                                                "&:hover fieldset": { border: "none" },
                                                "&.Mui-focused fieldset": { border: "none" },
                                            },
                                        }}
                                    />
                                )}
                            </Box>
                        </TableCell>
                    ))}
                </TableRow>
            }
            <TableRow sx={{ position: "sticky", top: showFilters ? "2.3rem" : 0, backgroundColor: "#cde2f8", zIndex: 4 }}>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        sx={{
                            borderRightWidth: 1,
                            borderRightStyle: "solid",
                            borderRightColor: "grey.300",
                            bgcolor: "#cde2f8",
                            padding: headCell.disablePadding ? "none" : "normal",
                            width: headCell.width,
                            // textAlign: headCell.numeric ? "center" : "center",
                            ...(headCell.isSticky && {
                                position: "sticky",
                                [headCell.isSticky.position]: headCell.isSticky.positionStart || 0,
                                zIndex: headCell.isSticky.zIndex ?? 6,
                            }),
                        }}
                    >
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Box sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</Box>
                            {headCell.isSorting && (
                                <Box sx={{ display: "flex" }}>
                                    <IconButton size="small" onClick={() => handleSortingChange(headCell.id, orderBy)}>
                                        <UnfoldMoreIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            )}
                        </Box>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>

    );
};

export default TableHeadList;
